
// import React, { useEffect } from "react";
// import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";

// // Import your components
// import Home from "./components/Home";
// import PrivacyPolicy from "./components/PrivacyPolicy";
// import Contact from "./components/Contact";
// import ResetPasswordRedirect from "./components/ResetPassword";
// import AppLayout from "./AppLayout";
// import ProtectedAdminRoute from "./components/Admin/ProtectedAdminRoute";
// import Login from "./components/Admin/Login";
// import Register from "./components/Admin/Register";

// // Import admin pages
// import AdminDashboard from "./components/Admin/Dashboard";
// import Customers from "./components/Admin/admin/Customers";
// import Cleaners from "./components/Admin/admin/Cleaners";
// import UserRoles from "./components/Admin/admin/UserRoles";
// import Settings from "./components/Admin/admin/Settings";
// import DashboardPage from "./components/Admin/admin/DashboardPage";
// import Payout from "./components/Admin/admin/Payout";
// import Services from "./components/Admin/admin/Services";
// import ServiceAreas from "./components/Admin/admin/ServiceAreas";
// import Scheduling from "./components/Admin/admin/Scheduling";
// import Notifications from "./components/Admin/admin/Notifications";
// import Reviews from "./components/Admin/admin/Reviews";
// import JobHistory from "./components/Admin/admin/JobHistory";

// // Import your colors
// import COLORS from "./components/colors";
// import './App.css';
// import Analytics from "./components/Admin/admin/Analytics";
// import CleanerHome from "./components/CleanerHome";
// // import CleanerLanding from "./components/CleanerLanding";

// // Import all new pages
// import About from "./components/Pages/Company/About";
// import Team from "./components/Pages/Company/Team";
// import Careers from "./components/Pages/Company/Careers";
// import Press from "./components/Pages/Company/Press";
// import Blog from "./components/Pages/Company/Blog";
// import AirbnbCleaning from "./components/Pages/Services/AirbnbCleaning";

// import DeepCleaning from "./components/Pages/Services/DeepCleaning";
// import MoveCleaning from "./components/Pages/Services/MoveCleaning";

// // import DeepCleaning from "./components/Pages/services/DeepCleaning";
// // import MoveCleaning from "./components/Pages/services/MoveCleaning";
// import Commercial from "./components/Pages/Services/Commercial";
// import CleanerApp from "./components/Pages/Cleaners/CleanerApp";
// import Training from "./components/Pages/Cleaners/Training";
// import CleanerSupport from "./components/Pages/Cleaners/Support";
// import CleanerEarnings from "./components/Pages/Cleaners/Earnings";
// import HelpCenter from "./components/Pages/Support/HelpCenter";
// import FAQs from "./components/Pages/Support/FAQs";
// import ServiceAreasPage from "./components/Pages/Support/ServiceAreas";
// import BookingHelp from "./components/Pages/Support/BookingHelp";
// import Terms from "./components/Pages/Legal/Terms";
// import Cookies from "./components/Pages/Legal/Cookies";
// import Insurance from "./components/Pages/Legal/Insurance";
// import Compliance from "./components/Pages/Legal/Compliance";

// import AutomaticScheduling from "./components/Pages/Features/AutomaticScheduling";
// import InAppMessaging from "./components/Pages/Features/InAppMessaging";
// import AutoPayment from "./components/Pages/Features/AutoPayment";
// import BeforeAfterPhotos from "./components/Pages/Features/BeforeAfterPhotos";
// import CleanlinessScore from "./components/Pages/Features/CleanlinessScore";
// import TaskChecklist from "./components/Pages/Features/TaskChecklist";

// import VacationRental from "./components/Pages/Services/VacationRental";
// import Pricing from "./components/Pages/Company/Pricing";
// import OnboardingComplete from "./components/OnBoardingComplete";
// // import OnboardingComplete from "./components/OnBoardingComplete";



// const theme = createTheme({
//   palette: {
//     primary: {
//       main: COLORS.primary,
//       light: COLORS.primary_light,
//       dark: COLORS.darkBlue,
//       contrastText: COLORS.white,
//     },
//     secondary: {
//       main: COLORS.secondary,
//       light: COLORS.light_gray,
//       dark: COLORS.dark,
//       contrastText: COLORS.white,
//     },
//     background: {
//       default: COLORS.backgroundColor,
//       paper: COLORS.white,
//     },
//     text: {
//       primary: COLORS.black,
//       secondary: COLORS.gray,
//     },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h4: {
//       fontWeight: 700,
//       color: COLORS.black,
//     },
//     h5: {
//       fontWeight: 600,
//       color: COLORS.black,
//     },
//     h6: {
//       fontWeight: 600,
//       color: COLORS.black,
//     },
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           fontWeight: 600,
//         },
//       },
//     },
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           boxShadow: '0 2px 12px rgba(36, 48, 63, 0.08)',
//         },
//       },
//     },
//   },
// });

// // Create a DeepLinkHandler component
// const DeepLinkHandler = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Check if this is a mobile deep link route
//     const mobileRoutes = [
//       // '/verify-email',
//       // '/reset-password',
//       // '/onboarding-complete', 
//       // '/verification-complete',
//       // '/payment-complete',
//       '/schedule-review'
//     ];

//     const isMobileRoute = mobileRoutes.some(route => 
//       location.pathname.startsWith(route)
//     );

//     if (isMobileRoute) {
//       // Show a nice landing page for mobile deep links
//       console.log('Mobile deep link accessed:', location.pathname);
      
//       // You can show a message or redirect to app store
//       setTimeout(() => {
//         // Redirect to home or app download page after showing message
//         navigate('/');
//       }, 3000);
//     }
//   }, [location, navigate]);

//   return (
//     <div style={{ padding: '2rem', textAlign: 'center' }}>
//       <h2>📱 FreshSweeper Mobile App</h2>
//       <p>This link is intended to open in the FreshSweeper mobile app.</p>
//       <p>If you have the app installed, it should open automatically.</p>
//       <p>If not, please download the app from the App Store or Google Play.</p>
//       <p>Redirecting to homepage in 3 seconds...</p>
//     </div>
//   );
// };

// function App() {
//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Router>
//         <Routes>
          
//           {/* Add these mobile deep link routes */}
//           {/* <Route path="/verify-email" element={<DeepLinkHandler />} />
//           <Route path="/reset-password/:token" element={<DeepLinkHandler />} />
//           <Route path="/onboarding-complete" element={<DeepLinkHandler />} />
//           <Route path="/verification-complete" element={<DeepLinkHandler />} />
//           <Route path="/payment-complete" element={<DeepLinkHandler />} />
//           <Route path="/schedule-review/:scheduleId" element={<DeepLinkHandler />} />
//            */}
//           {/* Public routes with AppLayout */}
//           <Route path="/onboarding-complete" element={<OnboardingComplete />} />
//           <Route path="/" element={<AppLayout />}>
//             <Route index element={<Home />} />
//             <Route path="contact" element={<Contact />} />
//             <Route path="reset-password" element={<ResetPasswordRedirect />} />
//             <Route path="privacyp" element={<PrivacyPolicy />} />
//             {/* <Route path="become-a-cleaner" element={<CleanerLanding />} /> */}
            
            
//             {/* Onboarding Pages */}
//             {/* REMOVED: <Route path="onboarding-complete" element={<OnboardingComplete />} /> */}

//             {/* Company Pages */}
//             <Route path="about" element={<About />} />
//             <Route path="team" element={<Team />} />
//             <Route path="careers" element={<Careers />} />
//             <Route path="press" element={<Press />} />
//             <Route path="pricing" element={<Pricing />} />
//             <Route path="blog" element={<Blog />} />

//             <Route path="features/automatic-scheduling" element={<AutomaticScheduling />} />
//             <Route path="features/in-app-messaging" element={<InAppMessaging />} />
//             <Route path="features/auto-payment" element={<AutoPayment />} />
//             <Route path="features/before-after-photos" element={<BeforeAfterPhotos />} />
//             <Route path="features/cleanliness-score" element={<CleanlinessScore />} />
//             <Route path="features/task-checklist" element={<TaskChecklist />} />
                        
//             {/* Services Pages */}
//             <Route path="services/airbnb" element={<AirbnbCleaning />} />
//             <Route path="services/vacation-rental" element={<VacationRental />} />
//             <Route path="services/deep-cleaning" element={<DeepCleaning />} />
//             <Route path="services/move-cleaning" element={<MoveCleaning />} />
//             <Route path="services/commercial" element={<Commercial />} />
            
//             {/* Cleaner Pages */}
//             <Route path="cleaner-app" element={<CleanerApp />} />
//             <Route path="training" element={<Training />} />
//             <Route path="cleaner-support" element={<CleanerSupport />} />
//             <Route path="earnings" element={<CleanerEarnings />} />
            
//             {/* Support Pages */}
//             <Route path="help" element={<HelpCenter />} />
//             <Route path="faqs" element={<FAQs />} />
//             <Route path="service-areas" element={<ServiceAreasPage />} />
//             <Route path="booking-help" element={<BookingHelp />} />
            
//             {/* Legal Pages */}
//             <Route path="terms" element={<Terms />} />
//             <Route path="cookies" element={<Cookies />} />
//             <Route path="insurance" element={<Insurance />} />
//             <Route path="compliance" element={<Compliance />} />
//           </Route>

//           {/* Cleaner routes */}
//           <Route path="/cleaner" element={<AppLayout />}>
//             <Route index element={<CleanerHome />} />
//           </Route>

//           {/* Admin login/register (public) */}
//           <Route path="/admin/login" element={<Login />} />
//           <Route path="/admin/register" element={<Register />} />

//           {/* Protected admin routes with AdminDashboard layout */}
//           <Route 
//             path="/admin/*" 
//             element={
//               <ProtectedAdminRoute>
//                 <AdminDashboard />
//               </ProtectedAdminRoute>
//             } 
//           >
//             {/* Default admin route */}
//             <Route index element={<DashboardPage />} />
            
//             {/* User Management Routes */}
//             <Route path="users" element={<Customers />} />
//             <Route path="customers" element={<Customers />} />
//             <Route path="cleaners" element={<Cleaners />} />
//             <Route path="user-roles" element={<UserRoles />} />
            
//             {/* Scheduling Routes */}
//             <Route path="calendar" element={<Scheduling view="calendar" />} />
//             <Route path="upcoming-jobs" element={<Scheduling view="upcoming" />} />
//             <Route path="job-history" element={<JobHistory view="history" />} />
            
//             {/* Service Management Routes */}
//             <Route path="services" element={<Services />} />
//             <Route path="pricing" element={<Services />} />
//             <Route path="service-areas" element={<ServiceAreas />} />
            
//             {/* Financial Routes */}
//             <Route path="payout" element={<Payout />} />
//             <Route path="invoices" element={<Payout />} />
//             <Route path="earnings" element={<Payout />} />
//             <Route path="transactions" element={<Payout />} />
            
//             {/* Content & Communication Routes */}
//             <Route path="reviews" element={<Reviews />} />
//             <Route path="notifications" element={<Notifications />} />
//             <Route path="promotions" element={<Notifications />} />
            
//             {/* Other Admin Routes */}
//             <Route path="analytics" element={<Analytics />} />
//             <Route path="settings" element={<Settings />} />
//           </Route>

//           {/* Fallback route */}
//           <Route path="*" element={<div>404 - Page Not Found</div>} />
//         </Routes>
//       </Router>
//     </ThemeProvider>
//   );
// }

// export default App;



import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Import your components
import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Contact from "./components/Contact";
import ResetPasswordRedirect from "./components/ResetPassword";
import AppLayout from "./AppLayout";
import ProtectedAdminRoute from "./components/Admin/ProtectedAdminRoute";
import Login from "./components/Admin/Login";
import Register from "./components/Admin/Register";

// Import admin pages
import AdminDashboard from "./components/Admin/Dashboard";
import Customers from "./components/Admin/admin/Customers";
import Cleaners from "./components/Admin/admin/Cleaners";
import UserRoles from "./components/Admin/admin/UserRoles";
import Settings from "./components/Admin/admin/Settings";
import DashboardPage from "./components/Admin/admin/DashboardPage";
import Payout from "./components/Admin/admin/Payout";
import Services from "./components/Admin/admin/Services";
import ServiceAreas from "./components/Admin/admin/ServiceAreas";
import Scheduling from "./components/Admin/admin/Scheduling";
import Notifications from "./components/Admin/admin/Notifications";
import Reviews from "./components/Admin/admin/Reviews";
import JobHistory from "./components/Admin/admin/JobHistory";

// Import your colors
import COLORS from "./components/colors";
import './App.css';
import Analytics from "./components/Admin/admin/Analytics";
import CleanerHome from "./components/CleanerHome";

// Import all new pages
import About from "./components/Pages/Company/About";
import Team from "./components/Pages/Company/Team";
import Careers from "./components/Pages/Company/Careers";
import Press from "./components/Pages/Company/Press";
import Blog from "./components/Pages/Company/Blog";
import AirbnbCleaning from "./components/Pages/Services/AirbnbCleaning";

import DeepCleaning from "./components/Pages/Services/DeepCleaning";
import MoveCleaning from "./components/Pages/Services/MoveCleaning";
import Commercial from "./components/Pages/Services/Commercial";
import CleanerApp from "./components/Pages/Cleaners/CleanerApp";
import Training from "./components/Pages/Cleaners/Training";
import CleanerSupport from "./components/Pages/Cleaners/Support";
import CleanerEarnings from "./components/Pages/Cleaners/Earnings";
import HelpCenter from "./components/Pages/Support/HelpCenter";
import FAQs from "./components/Pages/Support/FAQs";
import ServiceAreasPage from "./components/Pages/Support/ServiceAreas";
import BookingHelp from "./components/Pages/Support/BookingHelp";
import Terms from "./components/Pages/Legal/Terms";
import Cookies from "./components/Pages/Legal/Cookies";
import Insurance from "./components/Pages/Legal/Insurance";
import Compliance from "./components/Pages/Legal/Compliance";

import AutomaticScheduling from "./components/Pages/Features/AutomaticScheduling";
import InAppMessaging from "./components/Pages/Features/InAppMessaging";
import AutoPayment from "./components/Pages/Features/AutoPayment";
import BeforeAfterPhotos from "./components/Pages/Features/BeforeAfterPhotos";
import CleanlinessScore from "./components/Pages/Features/CleanlinessScore";
import TaskChecklist from "./components/Pages/Features/TaskChecklist";

import VacationRental from "./components/Pages/Services/VacationRental";
import Pricing from "./components/Pages/Company/Pricing";
// import OnboardingComplete from "./components/OnboardingComplete";
// import OnboardingComplete from "./components/OnBoardingComplete";
import OnboardingComplete from "./components/OnboardingComplete";
import IDVerificationComplete from "./components/IDeverificationComplete";
import InviteLanding from "./components/InviteLanding";
import Copies from "./components/Admin/admin/Copies";

const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary,
      light: COLORS.primary_light,
      dark: COLORS.darkBlue,
      contrastText: COLORS.white,
    },
    secondary: {
      main: COLORS.secondary,
      light: COLORS.light_gray,
      dark: COLORS.dark,
      contrastText: COLORS.white,
    },
    background: {
      default: COLORS.backgroundColor,
      paper: COLORS.white,
    },
    text: {
      primary: COLORS.black,
      secondary: COLORS.gray,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
      color: COLORS.black,
    },
    h5: {
      fontWeight: 600,
      color: COLORS.black,
    },
    h6: {
      fontWeight: 600,
      color: COLORS.black,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(36, 48, 63, 0.08)',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* ✅ MOVE OnboardingComplete OUTSIDE AppLayout */}
          <Route path="/onboarding-complete" element={<OnboardingComplete />} />
          <Route path="/id-verification-complete" element={<IDVerificationComplete />} />
          {/* <Route path="/redirect/reset-password/:token" element={<ResetPasswordRedirect />} /> */}
          {/* <Route path="redirect/reset-password/:token" element={<ResetPasswordRedirect />} /> */}

          <Route path="redirect/reset-password/:token" element={<ResetPasswordRedirect />} />
          <Route path="/invite/:token" element={<InviteLanding />} />
      
          {/* Public routes with AppLayout */}
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Home />} />
            <Route path="contact" element={<Contact />} />
            
            <Route path="privacyp" element={<PrivacyPolicy />} />
            
            {/* ❌ REMOVE the duplicate onboarding-complete route from here */}
            {/* <Route path="onboarding-complete" element={<OnboardingComplete />} /> */}

            {/* Company Pages */}
            <Route path="about" element={<About />} />
            <Route path="team" element={<Team />} />
            <Route path="careers" element={<Careers />} />
            <Route path="press" element={<Press />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="blog" element={<Blog />} />

            <Route path="features/automatic-scheduling" element={<AutomaticScheduling />} />
            <Route path="features/in-app-messaging" element={<InAppMessaging />} />
            <Route path="features/auto-payment" element={<AutoPayment />} />
            <Route path="features/before-after-photos" element={<BeforeAfterPhotos />} />
            <Route path="features/cleanliness-score" element={<CleanlinessScore />} />
            <Route path="features/task-checklist" element={<TaskChecklist />} />
                        
            {/* Services Pages */}
            <Route path="services/airbnb" element={<AirbnbCleaning />} />
            <Route path="services/vacation-rental" element={<VacationRental />} />
            <Route path="services/deep-cleaning" element={<DeepCleaning />} />
            <Route path="services/move-cleaning" element={<MoveCleaning />} />
            <Route path="services/commercial" element={<Commercial />} />
            
            {/* Cleaner Pages */}
            <Route path="cleaner-app" element={<CleanerApp />} />
            <Route path="training" element={<Training />} />
            <Route path="cleaner-support" element={<CleanerSupport />} />
            <Route path="earnings" element={<CleanerEarnings />} />
            
            {/* Support Pages */}
            <Route path="help" element={<HelpCenter />} />
            <Route path="faqs" element={<FAQs />} />
            <Route path="service-areas" element={<ServiceAreasPage />} />
            <Route path="booking-help" element={<BookingHelp />} />
            
            {/* Legal Pages */}
            <Route path="terms" element={<Terms />} />
            <Route path="cookies" element={<Cookies />} />
            <Route path="insurance" element={<Insurance />} />
            <Route path="compliance" element={<Compliance />} />
          </Route>

          {/* Cleaner routes */}
          <Route path="/cleaner" element={<AppLayout />}>
            <Route index element={<CleanerHome />} />
          </Route>

          {/* Admin login/register (public) */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/register" element={<Register />} />

          {/* Protected admin routes with AdminDashboard layout */}
          <Route 
            path="/admin/*" 
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            } 
          >
            {/* Default admin route */}
            <Route index element={<DashboardPage />} />
            
            {/* User Management Routes */}
            <Route path="users" element={<Customers />} />
            <Route path="customers" element={<Customers />} />
            <Route path="cleaners" element={<Cleaners />} />
            <Route path="user-roles" element={<UserRoles />} />
            
            {/* Scheduling Routes */}
            <Route path="calendar" element={<Scheduling view="calendar" />} />
            <Route path="upcoming-jobs" element={<Scheduling view="upcoming" />} />
            <Route path="job-history" element={<JobHistory view="history" />} />
            
            {/* Service Management Routes */}
            <Route path="services" element={<Services />} />
            <Route path="pricing" element={<Services />} />
            <Route path="service-areas" element={<ServiceAreas />} />
            
            {/* Financial Routes */}
            <Route path="payout" element={<Payout />} />
            <Route path="invoices" element={<Payout />} />
            <Route path="earnings" element={<Payout />} />
            <Route path="transactions" element={<Payout />} />
            
            {/* Content & Communication Routes */}
            <Route path="reviews" element={<Reviews />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="promotions" element={<Notifications />} />
            
            {/* Content & Management System */}
            <Route path="copies" element={<Copies />} />  {/* ✅ CMS */}
            
            
            {/* Other Admin Routes */}
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Fallback route */}
          <Route path="*" element={<div>404 - Page Not Found</div>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;